import React from "react";

import "./ProfileAttachmentsBreadcrumb.scss";

export interface CategoryFolder {
  id: string;
  name: string;
  [key: string]: unknown;
}

interface ProfileAttachmentsBreadcrumbProps {
  selectedCategory: CategoryFolder | null;
  onBackToCategories?: () => void;
  attachmentsLabel?: string;
}

const ProfileAttachmentsBreadcrumb: React.FC<
  ProfileAttachmentsBreadcrumbProps
> = ({
  selectedCategory,
  onBackToCategories,
  attachmentsLabel = "Attachments",
  onRefetch,
}) => {
  const breadcrumbs = [attachmentsLabel, selectedCategory?.name].filter(
    Boolean,
  );
  const handleBack = () => {
    onBackToCategories?.();
    onRefetch?.();
  };

  return (
    <div className="profile-attachments-breadcrumbs flex justify-content-between align-items-center">
      <div className="flex align-items-center">
        {selectedCategory && onBackToCategories && (
          <i
            className="pi pi-arrow-left folder-back-icon"
            onClick={handleBack}
            onKeyDown={(e) => e.key === "Enter" && handleBack()}
            role="button"
            tabIndex={0}
            aria-label="Back to categories"
          />
        )}
        <p className="profile-attachments-breadcrumbs__text">
          {breadcrumbs.slice(0, -1).map((crumb, index) => (
            <span key={index} className="document-heading">
              {crumb} /{" "}
            </span>
          ))}
          {breadcrumbs.length > 0 && (
            <span className="document-bold-heading">{breadcrumbs.at(-1)}</span>
          )}
        </p>
      </div>
    </div>
  );
};

export default ProfileAttachmentsBreadcrumb;
